import { defineComponent as _defineComponent } from 'vue'
import type { FormModel } from "ant-design-vue"
import { message } from "ant-design-vue"
import { computed, reactive, ref, watch } from "vue"

import InfiniteScrollSelect from "@/components/Common/InfiniteScrollSelect/index.vue"
import useForm from "@/composables/useForm"
import { useServerFormErrors } from "@/composables/useServerFormErrors"
import i18n from "@/i18n"
import { fetchAttributeUnits, translateText } from "@/modules/offers/api/productModeration"
import type {
  AttributeFormLocale,
  CreateAttributeValueFormValues
} from "@/modules/offers/types/createOffer"
import type {
  AttributeValueType,
  ProductModerationAttributeValue
} from "@/modules/offers/types/offers"

import { findOrCreateAttributeValue } from "../../utils/findOrCreateAttributeValue"

type Props = {
  visible?: boolean
  attributeCode?: string
  attributeValueType?: AttributeValueType
}
type Emits = {
  (e: "close"): void
  (e: "submit", data: ProductModerationAttributeValue): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAttributeValueModal',
  props: {
    visible: { type: Boolean },
    attributeCode: null,
    attributeValueType: null
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void
  (e: "submit", data: ProductModerationAttributeValue): void
}), expose: any, slots: any, attrs: any }) {

const props: Props = __props as {
  visible?: boolean
  attributeCode?: string
  attributeValueType?: AttributeValueType
};




const formRef = ref<FormModel>()
const form = reactive<CreateAttributeValueFormValues>({
  value_mlang: { uk: "", ru: "" },
  value: undefined,
  unit: undefined
})

const { validateForm, isValidForm, resetFields } = useForm(formRef)
const { getFieldErrorProps, setServerErrors, clearServerError, clearServerErrors } =
  useServerFormErrors()

const formRules = computed(() => {
  const required = [
    {
      required: true,
      whitespace: true,
      message: `${i18n.t("offers.product_moderation_errors.required")}`
    }
  ]

  if (props.attributeValueType === "STRING") {
    return { "value_mlang.uk": required, "value_mlang.ru": required }
  }

  return {
    value: [
      {
        required: true,
        type: "number",
        message: `${i18n.t("offers.product_moderation_errors.required")}`
      }
    ]
  }
})

const onClose = () => {
  emit("close")
}
const handleUnitChange = (value?: string) => {
  form.unit = value
  clearServerError("unit")
}

const isFetching = ref<boolean>(false)
const translatingLocale = ref<AttributeFormLocale>()

const isBusy = computed(() => isFetching.value || !!translatingLocale.value)

const translateValue = async (locale: AttributeFormLocale) => {
  if (isBusy.value) return

  const text = form.value_mlang[locale]

  if (!text) return

  const targetLocale = locale === "uk" ? "ru" : "uk"
  translatingLocale.value = locale
  try {
    const { data } = await translateText({ text, target_locale: targetLocale })
    form.value_mlang[targetLocale] = data.text.trim()
    clearServerError(`value_mlang.${targetLocale}`)
    formRef.value.clearValidate(`value_mlang.${targetLocale}`)
  } catch (error) {
    setServerErrors(error, { text: [`value_mlang.${locale}`] })
  } finally {
    translatingLocale.value = undefined
  }
}
const onSubmit = async () => {
  console.log("123")

  if (isBusy.value) return

  clearServerErrors()
  isFetching.value = true
  try {
    await validateForm()

    if (!isValidForm.value) {
      message.error(`${i18n.t("offers.offer_form_validate_error")}`)
      return
    }

    const value = await findOrCreateAttributeValue({
      attributeCode: props.attributeCode,
      attributeValueType: props.attributeValueType,
      formValues: form
    })

    console.log("value", value)

    emit("submit", value)
    onClose()
  } catch (error) {
    console.log("error", error)
    const valueFields =
      props.attributeValueType === "STRING" ? ["value_mlang.uk", "value_mlang.ru"] : ["value"]
    setServerErrors(error, { value: valueFields, value_mlang: valueFields })
  } finally {
    isFetching.value = false
  }
}

watch(
  () => props.visible,
  (value) => {
    if (!value) {
      resetFields()
      clearServerErrors()
      form.value_mlang.uk = ""
      form.value_mlang.ru = ""
      form.value = undefined
      form.unit = undefined
    }
  }
)

return { __sfc: true,props, emit, formRef, form, validateForm, isValidForm, resetFields, getFieldErrorProps, setServerErrors, clearServerError, clearServerErrors, formRules, onClose, handleUnitChange, isFetching, translatingLocale, isBusy, translateValue, onSubmit, InfiniteScrollSelect, fetchAttributeUnits }
}

})